module.exports = require("@gauzy/plugin-integration-github");